<!-- 产品对比 -->
<template>
  <div class="compareSwiper">
    <div class="compareSwiper-title" data-aos="fade-down" data-aos-delay="100">
      产品对比
    </div>
    <swiper
      class="swiper"
      :options="swiperOption"
      data-aos="fade-down"
      data-aos-delay="100"
    >
      <swiper-slide v-for="item in compareList" :key="item.other">
        <div class="compareSwiper-item">
          <div class="compareSwiper-item-title">
            <div class="compareSwiper-item-title-left">{{ item.other }}</div>
            <div class="compareSwiper-item-title-left">{{ item.abke }}</div>
            <!-- <div class="vs-icon">
              <div class="vs-icon-text">VS</div>
              <div class="line"></div>
            </div> -->
          </div>
          <div class="compareSwiper-item-content">
            <div
              class="compareSwiper-item-content-left"
              v-for="(node, index) in item.otherData"
              :key="node"
            >
              <div class="compareSwiper-item-content-left-title borderRight">
                {{ node }}
              </div>
              <div class="compareSwiper-item-content-left-title">
                <span
                  v-if="item.abkeData[index]"
                  class="iconfont icon-duihao"
                ></span>
                {{ item.abkeData[index] }}
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  props: {
    dataList: {
      type: Object,
      default: [],
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      compareList: this.dataList,
      // modules: [EffectCoverflow, Pagination, Autoplay, Navigation],
      swiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 1,
          scale: 1.14,
          depth: 345,
          modifier: 2.62,
          slideShadows: true,
        },
        autoplay: false,
        loop: true,
        loopedSlides: 2,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>
<style lang="sass" scoped>

.compareSwiper {
  position: relative;
  width: 100%;
  margin-bottom:80px;
  background: url('~@/assets/product/产品对比.png') ;
  background-size: cover;
  padding: 60px 0 40px 0;
  .compareSwiper-title {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 500;
font-size: 32px;
color: #000000;
margin-bottom: 60px;
text-align: center;
  }
  .swiper-slide {
    border-radius: 40px 40px 20px 20px;
    width: 1100px;
  }
  .compareSwiper-item {
.compareSwiper-item-title {
  border-bottom: 1px solid #EFEFEF;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  .compareSwiper-item-title-left {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 500;
font-size: 24px;
flex: 1;
text-align: center;
color: #FFFFFF;
  }
  background: url('~@/assets/product/对比bg.png') ;
  background-size: cover;
  border-radius: 40px;
}
.compareSwiper-item-content {
  .compareSwiper-item-content-left {
    height: 90px;
    display: flex;
    border-bottom: 1px solid #EFEFEF;
    .borderRight {
      border-right: 1px solid #EFEFEF;
    }
    .compareSwiper-item-content-left-title {
      flex: 1;
      display: flex;
  align-items: center;
      padding: 20px 20px 20px 35px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 400;
font-size: 16px;
color: #333333;
.iconfont {
  color: #3D86F5;
  font-size: 15px;
  margin-right: 20px;
}
    }
  }
}
  }
}
.compareSwiper .swiper {
  padding-bottom: 80px;
}
.compareSwiper .swiper-slide {
  background: #fff;
 box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.1000)
}
.swiper-button-prev,.swiper-button-next{
  color:#fff;
  background:rgba(0,0,0,.1);
  height:60px;
  width:60px;
  border-radius: 50%;

}
.swiper-button-next:hover,.swiper-button-prev:hover{
   background:rgba(0,0,0,.3);
}
.swiper-button-prev:after, .swiper-button-next:after{
  font-size:14px;
}
.compareSwiper .swiper-slide img {
  display: block;
  width:100%
}
.compareSwiper .swiper-slide p {
  line-height: 98px;
  padding-top: 0;
  text-align: center;
  color: #333;
  font-size: 26px;
  margin: 0;
}
::v-deep .swiper-container-3d .swiper-slide-shadow-right{
  background:none;
}
::v-deep .swiper-container-3d .swiper-slide-shadow-left{
  background:none;
}
.compareSwiper .swiper-pagination {
  width: 100%;
  bottom: 0px;
}
::v-deep .swiper-pagination-bullet{
  width:43px;
  height:5px;
  border-radius: 2px !important;
}
.compareSwiper .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 5px;
  border: 3px solid #fff;
  background-color: #d5d5d5;
  width: 10px;
  height: 10px;
  opacity: 1;
}

.compareSwiper .swiper-pagination-bullets .swiper-pagination-bullet-active {
  border: 3px solid #00aadc;
  background-color: #fff;
}
</style>
